module.exports = __webpack_public_path__ + "static/media/OpenSans-Regular.629a55a7.ttf";